import { UserRole } from '@wineryxplorer/shared';
import { FormSection } from '../../components/ui/FormSection';

const ROLE_OPTIONS = [
  { value: '', label: 'All Roles' },
  { value: UserRole.USER, label: 'User' },
  { value: UserRole.VENUE_ADMIN, label: 'Venue Admin' },
  { value: UserRole.SITE_ADMIN, label: 'Site Admin' },
  { value: UserRole.SUPER_ADMIN, label: 'Super Admin' },
];

const STATUS_OPTIONS = [
  { value: 'all', label: 'All Statuses' },
  { value: 'active', label: 'Active' },
  { value: 'deactivated', label: 'Deactivated' },
];

const EMAIL_VERIFIED_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Verified' },
  { value: 'false', label: 'Unverified' },
];

const FIELD_CLASSES =
  'w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-info-500 focus:ring-1 focus:ring-info-500 outline-none';

interface AdminUsersFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  role: UserRole | '';
  onRoleChange: (value: UserRole | '') => void;
  status: 'active' | 'deactivated' | 'all';
  onStatusChange: (value: 'active' | 'deactivated' | 'all') => void;
  emailVerified: '' | 'true' | 'false';
  onEmailVerifiedChange: (value: '' | 'true' | 'false') => void;
}

export const AdminUsersFilters = ({
  search,
  onSearchChange,
  role,
  onRoleChange,
  status,
  onStatusChange,
  emailVerified,
  onEmailVerifiedChange,
}: AdminUsersFiltersProps) => (
  <div className="bg-gray-50 rounded-lg border border-gray-200 p-4">
    <FormSection
      title="Filters"
      titleAs="h3"
      divider={false}
      className="mt-0"
      contentClassName="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
    >
      {/* Search */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Search</label>
        <input
          type="text"
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Name, username, or email..."
          className={FIELD_CLASSES}
        />
      </div>

      {/* Role filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Role</label>
        <select
          value={role}
          onChange={(e) => onRoleChange(e.target.value as UserRole | '')}
          className={FIELD_CLASSES}
        >
          {ROLE_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* Status filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Status</label>
        <select
          value={status}
          onChange={(e) => onStatusChange(e.target.value as 'active' | 'deactivated' | 'all')}
          className={FIELD_CLASSES}
        >
          {STATUS_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      {/* Email verified filter */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
        <select
          value={emailVerified}
          onChange={(e) => onEmailVerifiedChange(e.target.value as '' | 'true' | 'false')}
          className={FIELD_CLASSES}
        >
          {EMAIL_VERIFIED_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>
    </FormSection>
  </div>
);
